/**
 * Canvas configuration for direction-based relationship defaulting.
 *
 * Angles follow the atan2 / screen convention:
 *   0°   = right
 *   90°  = down  (y increases downward on screen)
 *   180° = left
 *   270° = up
 *
 * All angles are normalised to [0, 360) before comparison.
 * Each range is half-open: [min, max).
 * Ranges are evaluated in declaration order; first match wins.
 */

export interface AngleRange {
  min: number;
  max: number;
}

export interface DragDirectionConfig {
  child: AngleRange[];
  parent: AngleRange[];
  spouse: AngleRange[];
  fallback: string;
}

/**
 * Default angle-to-relationship mapping used when the user drags from one
 * person node to another on the canvas.
 *
 * - Drag DOWN  → child   (target is below source — a descendant)
 * - Drag UP    → parent  (target is above source — an ancestor)
 * - Drag LEFT  → spouse  (lateral relationship)
 * - Drag RIGHT → spouse  (lateral relationship)
 *
 * The user can always override the pre-selected type inside AddRelationshipModal.
 */
export const DRAG_DIRECTION_RELATIONSHIP_DEFAULTS: DragDirectionConfig = {
  child:  [{ min: 45,  max: 135 }],
  parent: [{ min: 225, max: 315 }],
  spouse: [
    { min: 315, max: 360 },
    { min: 0,   max: 45  },
    { min: 135, max: 225 },
  ],
  fallback: 'sibling',
};
